import cx from 'classnames'
import type React from 'react'

import css from './ParentCorners.module.scss'

type Props = {}

const ParentCorners: React.FC<Props> = () => {
  return (
    <div data-tree-connector className={cx(css.container, css.hasStraight)}>
      <>parent</>
      <div className={cx(css.corner, css.straight)} />
    </div>
  )
}

export default ParentCorners
